import { render, staticRenderFns } from "./HistoryIcon.vue?vue&type=template&id=2a316e1c"
import script from "./HistoryIcon.vue?vue&type=script&lang=js"
export * from "./HistoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports